export const ON_LOAD = 'ON_LOAD';
export const HIDE_MODAL = 'HIDE_MODAL';
export const ON_NAV_TOGGLE = 'ON_NAV_TOGGLE';
export const ON_ROUTE_CHANGE = 'ON_ROUTE_CHANGE';
export const ON_CHANGE_GAME_UP = 'ON_CHANGE_GAME_UP';
export const ON_CHANGE_GAME_DOWN = 'ON_CHANGE_GAME_DOWN';
export const ON_START_GAME = 'ON_START_GAME';
export const ON_STOP_GAME = 'ON_STOP_GAME';
export const ON_RESTART_GAME = 'ON_RESTART_GAME';
export const ON_NEXT_GAME = 'ON_NEXT_GAME';
export const ON_COUNT_DOWN = 'ON_COUNT_DOWN';
export const ON_COUNT_UP = 'ON_COUNT_UP';
export const ON_TRIGGER_GAME = 'ON_TRIGGER_GAME';
export const ON_CANCEL_GAME = 'ON_CANCEL_GAME';
export const ON_BLOCKS_MOUNTED = 'ON_BLOCKS_MOUNTED';
export const ON_BLOCK_SELECTED = 'ON_BLOCK_SELECTED';
export const ON_BLOCK_TARGETED = 'ON_BLOCK_TARGETED';
export const BLOCK_TRANSITION = 'BLOCK_TRANSITION';
export const ON_CHANGE_BLOCK_ORDER = 'ON_CHANGE_BLOCK_ORDER';
export const ON_CORRECT_BLOCK_ORDER = 'ON_CORRECT_BLOCK_ORDER';
export const CORRECT_BLOCK_ORDER = 'CORRECT_BLOCK_ORDER';
export const SAVE_GAME_RESULTS = 'SAVE_GAME_RESULTS';



// WEBPACK FOOTER //
// ./src/state-constants/stateConstants.js